/**
 * 刺繍サービス料
 */
export const EMBROIDERY_UNIT_PRICE = 550
